import { useTranslation } from 'react-i18next';

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { cn } from '@/lib/utils';
import { ProjectRole } from '@/modules/common/types/gql/graphql';

interface ProjectRoleSelectProps {
  value: ProjectRole;
  onValueChange: (value: ProjectRole) => void;
  disabled?: boolean;
  className?: string;
}

const roleConfig = {
  [ProjectRole.OWNER]: {
    label: 'owner',
  },
  [ProjectRole.MEMBER]: {
    label: 'member',
  },
} as const;

export const ProjectRoleSelect = ({
  value,
  onValueChange,
  disabled = false,
  className,
}: ProjectRoleSelectProps) => {
  const { t } = useTranslation();

  const getRoleLabel = (role: ProjectRole) =>
    t(`modules.mavue2.project.roles.${roleConfig[role].label}.label`);

  const getRoleDescription = (role: ProjectRole) =>
    t(`modules.mavue2.project.roles.${roleConfig[role].label}.description`);

  return (
    <Select value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger className={cn('w-[180px]', className)}>
        <SelectValue>{getRoleLabel(value)}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {Object.keys(roleConfig).map((role) => (
          <SelectItem key={role} value={role} className="py-3">
            <div className="flex flex-col items-start">
              <div className="font-medium">{getRoleLabel(role as ProjectRole)}</div>
              <div className="text-xs text-muted-foreground mt-0.5 max-w-[240px]">
                {getRoleDescription(role as ProjectRole)}
              </div>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
